export class DialogModelConfirmDisablePlatform {
    constructor(
    ) {}
  }
  